module.exports = __webpack_public_path__ + "img/bannerEmBreve.f484e738.jpeg";